import { ApplicationType, SearchHookProps } from '@into-discovery/browsewebshared';

export const defaultSearchParams: SearchHookProps = {
  page: 1,
  pageSize: 8,
  sortOrder: `1`,
  searchApiSettings: {
    baseUrl: `${process.env.NEXT_PUBLIC_SEARCH_SERVICE_URL}/v2`,
    searchTimeOut: 10000,
    b2cFlag: true,
    applicationType: ApplicationType.IntoStudy,
  },
};
